import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {


  api = environment.baseUrl;

  activeOrder = new BehaviorSubject(null);

  constructor(private httpClient: HttpClient) {

  }

  saveOrder(order: any): Observable<any> {
    return this.httpClient.post(this.api + "/order/kiosk/save", order);
  }

  createPaymentWithTransactionId(gatewayName: string, orderPayload: any): Observable<any> {
    return this.httpClient.post(this.api + "/order/card/" + gatewayName, orderPayload);
  }

  getOrderTypes(storeId: number): Observable<any> {
    return this.httpClient.get(`${this.api}/store/${storeId}/orderTypes/qrapp`);
  }

  makeCreditCardPayment(onliePaymentModel: any, gatewayName: string): Observable<any> {
    return this.httpClient.post(this.api + '/order/kiosk/card/' + gatewayName, onliePaymentModel);
  }

  /**
  * create order for cashier by order and payment intent
  * @param order
  * @param paymetIntent
  */
  createOrderByCardReader(paymetIntent: string, gateway: string, order: any): Observable<any> {
    return this.httpClient.post(this.api + '/order/kiosk/card-reader/' + gateway + '/' + paymetIntent, order);
  }


  /**
   * delete order by id
   * @param orderId 
   * @returns 
   */
  deleteOrder(orderId: number): Observable<any> {
    return this.httpClient.delete(this.api + "/order/" + orderId);
  }

  /**
   * get coupon codes by client type
   * @param currDate 
   * @returns 
   */
  getCouponCodesByClientType(currDate: string): Observable<any> {
    return this.httpClient.get(this.api + "/promo-code/client-type/" + "indoor-kiosk?currDate=" + currDate);
  }

  /**
   * get coupon by coupon code
   * @param storeId 
   * @param couponCode 
   * @returns 
   */
  getCouponByCouponCode(storeId: number, couponCode: string): Observable<any> {
    return this.httpClient.get(this.api + "/promo-code/indoor-kiosk/" + storeId + '/' + couponCode);
  }


  markCardOrderAsPaid(id: number, paymentModel: any): Observable<any> {
    console.log('markCardOrderAsPaid called with:', id, paymentModel);
    return this.httpClient.post(
      this.api + 'order/paid/card/' + id,
      paymentModel,
      { withCredentials: true }
    );
  }


  createCardPaymentForOrderByPaymentIntent(orderId: number, paymentIntent: string, paymentModel: any): Observable<any> {
    console.log('createCardPaymentForOrderByPaymentIntent called with:', orderId, paymentIntent, paymentModel);
    return this.httpClient.post(
      this.api + 'order/cashier/payment/' + orderId + '/' + paymentIntent,
      paymentModel
    );
  }




  getOrderById(id: number): Observable<any> {
    return this.httpClient.get(this.api + '/order/admin/' + id, {
      withCredentials: true,
    });
  }

  parentCheckout(order: any): Observable<any> {
    return this.httpClient.post(this.api + "order/parent/checkout", order);
  }

  createOrderByCard(order: any): Observable<any> {
    return this.httpClient.post(this.api + 'order/card/checkout', order);
  }
}
